import React from "react";
import { FilterLabelProps, BaseInputFieldFilter } from "@duosoftbg/nacid-components";

const RecordNumberFilter = ({ label = "l.searchFilter.recordNumber", ...others }: FilterLabelProps) => {
  return (
    <>
      <BaseInputFieldFilter sm={6} md={3} fieldName={"recordNumber"} label={label} {...others} />
    </>
  );
};

export default RecordNumberFilter;
